import { CAR_DETAILE ,SALE_PRODUCT_LIST} from "../constant/index";

const INITIAL_STATE = {
  loading: false,
  data: [],
  productlist: [],
  productListStatus: "idle",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case `${CAR_DETAILE}_REQUEST`:
      return { ...state, loading: true };
    case `${CAR_DETAILE}_SUCCESS`:
      // console.log("MY_INTERSTE ...........MY_INTERSTE",action.payload)

      return { ...state, 
        data:action.payload,
        loading:false,
      };
    case `${CAR_DETAILE}_FAIL`:
      return { ...state, loading: false };
    case `${CAR_DETAILE}_ERROR`:
      return { ...state, loading: false };
    //
  // =======================product sale list====================
    case `${SALE_PRODUCT_LIST}_REQUEST`:
      return { ...state, loading: true, productListStatus: "loading" };
    case `${SALE_PRODUCT_LIST}_SUCCESS`:
      return {
        ...state,
        productlist: action.payload,
        loading: false,
        productListStatus: "success",
      };
    case `${SALE_PRODUCT_LIST}_FAIL`:
      return {
        ...state,
        productlist: [],
        loading: false,
        productListStatus: "error",
      };
    case `${SALE_PRODUCT_LIST}_ERROR`:
      return {
        ...state,
        productlist: [],
        loading: false,
        productListStatus: "error",
      };
    //
  
  
  
  
  }
  return state;
};
